import script from "./HrSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./HrSwitch.vue?vue&type=script&setup=true&lang=js"

import "./HrSwitch.vue?vue&type=style&index=0&id=65f023d7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65f023d7"]])

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QToggle,QIcon});
